<template>
  <div class="cell-content mx-2">
    <div v-if="isOnMobile">
      <div>
        <div class="cell-content">
          <div class="primary-text">
            <v-icon v-if="!voicemail.isRead" color="primary" x-small class="mr-2">mdi-circle</v-icon>
            <span :class="titleClass">
              {{ contactName }}
            </span>
          </div>
          <span class="sub-text" v-if="summaryEnabled && voicemail.transcriptionSummary">{{ voicemail.transcriptionSummary }}</span>
          <span class="sub-text" v-else>{{ $t('vmail.tip.noSummary') }}</span>
        </div>
      </div>
    </div>
    <div v-else>
      <msg-caller-number :voicemail="voicemail" :usedInList="usedInList" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import MsgCallerNumber from '@/components/voicemails/msg_caller_number'

export default {
  name: 'voicemail-msgs-table-callerName-column',
  components: { MsgCallerNumber },
  props: {
    voicemail: {
      type: Object,
      required: true
    },
    usedInList: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters({
      vmbox: 'voicemails/vmboxSettings',
      phoneNumbers: 'contacts/phoneNumbers/phoneNumbers'
    }),
    isOnMobile () {
      return this.$vuetify.breakpoint.mobile
    },
    summaryEnabled () {
      return this.vmbox?.summarize
    },
    contact () {
      return this.phoneNumbers?.find((phone) => parseInt(phone.phoneNumber) === parseInt(this.voicemail?.callerNum))
    },
    contactName () {
      return this.contact ? this.contact.name : this.voicemail?.callerName
    },
    titleClass () {
      return this.voicemail.isRead ? '' : 'font-weight-bold'
    }
  }
}
</script>

<style scoped>
</style>
